import { TabLogisticProps } from './tab-logistic.type'

import {
  CardOrderLogistic,
  CardOrderLogisticCost,
  CardOrderLogisticDocuments,
  CardOrderLogisticStatusHistory,
  CardOrderLogisticTransportOption,
  CardOrderShipmentInvoice,
  LogisticFormTabsEnum,
} from '@/components'
import { useParamsState } from '@/helpers'
import { useShipmentInvoiceList } from '@/services'
import { OrderLogisticDrawerForm } from '../../../components'
import styles from './tab-logistic.module.css'

export const TabLogistic = ({ saleOrder, isLoading }: TabLogisticProps) => {
  const [queryParams, setQueryParams] = useParamsState({
    form: '',
  })

  const totalQuantity = saleOrder?.items?.reduce(
    (acc, item) => acc + item.quantity,
    0,
  )

  const { data: dataShipmentInvoices, isLoading: isLoadingShipmentInvoices } =
    useShipmentInvoiceList(
      {
        limit: 9999,
        shipments_Order_Reference: saleOrder?.reference || '',
      },
      !!saleOrder?.reference,
    )

  return (
    <>
      <div className={styles.container}>
        <div>
          <CardOrderLogistic
            isLoading={!!isLoading}
            shipment={saleOrder?.shipments?.[0]}
            onEdit={() => setQueryParams({ form: 'transport' })}
            saleOrderStatus={saleOrder?.status}
          />
          <CardOrderLogisticTransportOption
            isLoading={!!isLoading}
            shipment={saleOrder?.shipments?.[0]}
            onEdit={() => setQueryParams({ form: 'transport' })}
            saleOrderStatus={saleOrder?.status}
          />
          <CardOrderLogisticCost
            isLoading={!!isLoading}
            shipment={saleOrder?.shipments?.[0]}
            totalQuantityShipment={totalQuantity}
            onEdit={() => setQueryParams({ form: 'costs' })}
            saleOrderStatus={saleOrder?.status}
          />
          <CardOrderLogisticStatusHistory
            isLoading={!!isLoading}
            shipmentStatusHistory={saleOrder?.shipments?.[0].statusHistory}
          />
        </div>

        <div>
          <CardOrderLogisticDocuments
            isLoading={!!isLoading}
            shipment={saleOrder?.shipments?.[0]}
            onEdit={() => setQueryParams({ form: 'internalDocuments' })}
            saleOrderStatus={saleOrder?.status}
          />

          <CardOrderShipmentInvoice
            isLoading={!!(isLoadingShipmentInvoices || isLoading)}
            shipmentInvoices={dataShipmentInvoices?.data?.results || []}
          />
        </div>
      </div>

      {saleOrder && (
        <OrderLogisticDrawerForm
          isOpen={!!queryParams.form}
          initialValues={saleOrder}
          onHandleClose={() => setQueryParams({ form: '' })}
          initialTab={
            (queryParams.form as keyof typeof LogisticFormTabsEnum) ||
            'transport'
          }
        />
      )}
    </>
  )
}
